import React, { useState } from "react";
import { Card, Form } from "react-bootstrap";
import { UseFormReturn, useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ImageLinksApi } from "../../../../../../../../../services/Api/Organization/types";
import { ImageLinksMode, ModalImageLinkItem } from "../../../utils/types";
import ImageLinkItem from "./ImageLinkItem";
import ImageLinksModal from "./ImageLinksModal";

interface Props {
	hideImageLinks: () => void;
	form: UseFormReturn<any>;
}

const ImageLinks = ({ form, hideImageLinks }: Props) => {
	const { t } = useTranslation();
	const { control } = form;
	const [modalImageLinkItem, setModalImageLinkItem] = useState<ModalImageLinkItem | undefined>(undefined);
	const { fields, append, remove, update } = useFieldArray({
		control,
		name: "image_links",
		keyName: "key",
	});

	const handleUpdateImage = (data: ImageLinksApi) => {
		if (modalImageLinkItem?.modalImageLinkItem) {
			update(modalImageLinkItem.index, {
				...data,
				image_link: data.image?.image_data ? undefined : data.image_link,
			});
		} else {
			append(data);
		}
		setModalImageLinkItem(undefined);
	};

	const handleClose = () => {
		setModalImageLinkItem(undefined);
		if (fields.length === 0) {
			hideImageLinks();
		}
	};

	const handleRemove = (index: number) => {
		remove(index);
		if (fields.length === 1) {
			hideImageLinks();
		}
	};

	const handleRemoveImage = () => {
		remove(modalImageLinkItem?.index);
		if (fields.length === 1) {
			hideImageLinks();
		}

		setModalImageLinkItem(undefined);
	};

	return (
		<>
			<Form.Label>{t("modules.menu.field.additional_photos.title")}</Form.Label>
			<Card className="image-link-card">
				<Card.Body>
					<div className="d-flex flex-wrap gap-2">
						{fields.map((field, index) => {
							return (
								<ImageLinkItem
									handleRemove={() => handleRemove(index)}
									handleEdit={() =>
										setModalImageLinkItem({ index, modalImageLinkItem: field as ImageLinksApi })
									}
									key={field.key}
									image={field}
									index={index}
									mode={ImageLinksMode.ADD_NEW}
								/>
							);
						})}
						<ImageLinkItem
							handleAppend={() => setModalImageLinkItem({ index: fields.length })}
							mode={ImageLinksMode.ADD_NEW}
						/>
					</div>
				</Card.Body>
			</Card>
			{modalImageLinkItem && (
				<ImageLinksModal
					handleRemove={handleRemoveImage}
					handleUpdate={handleUpdateImage}
					imageLinkItem={modalImageLinkItem.modalImageLinkItem}
					handleClose={handleClose}
					withTagsSelect
				/>
			)}
		</>
	);
};

export default ImageLinks;
